import React, { FormEventHandler } from 'react'
import {
    useStripe,
    useElements,
    CardElement,
} from '@stripe/react-stripe-js'
import { Stripe, StripeCardElement } from '@stripe/stripe-js'
import CouponFieldset from './CouponFieldset'
import { CouponInput } from 'types/coupon'
import { BookingForm } from 'types/booking'
import { DiscountType } from 'types/discount'
import Translation from 'components/Translation'
import { useTenantContext } from 'context/TenantContext'

const CARD_ELEMENT_OPTIONS = {
    classes: {
        base: 'w-full rounded-lg border border-gray-300 placeholder-gray-300 mt-1 py-3 px-4',
    },
}

export type CheckoutFormProps = {
    booking_data: BookingForm
    className?: string
    handleSubmit: FormEventHandler
    setBookingData(booking_data: BookingForm): void
    setCard(card: StripeCardElement): void
    setStripe(stripe: Stripe): void
    handleCouponChange?: (
        e: React.ChangeEvent<HTMLInputElement>
    ) => Promise<void>
}
export default function CheckoutForm(p: CheckoutFormProps) {
    const { stripe_connected_account_id } = useTenantContext()
    const stripe = useStripe()
    const elements = useElements()

    return stripe && (p.booking_data?.connected_account_id || stripe_connected_account_id) ? (
        <form
            onSubmit={(e) => {
                e.preventDefault()
                e.currentTarget.stripe = stripe
                p.handleSubmit(e)
            }}
            className={`${p.className || 'lg:mt-8'
                } flex flex-col gap-6 max-w-lg`}
        >
            <CardElement
                options={CARD_ELEMENT_OPTIONS}
                onChange={() => {
                    if (stripe && elements) {
                        const card = elements.getElement(CardElement)
                        if (card) {
                            p.setCard(card)
                        }
                        p.setStripe(stripe)
                    }
                }}
            />

            <CouponFieldset
                id={p.booking_data.membership_id}
                {...p.booking_data}
                label="booking.i_have_a_coupon"
                handleCouponChange={p?.handleCouponChange}
                onChange={(coupon: CouponInput) => {
                    if (coupon) {
                        let discount = coupon.discount_value
                        if (discount && p.booking_data.price) {
                            if (
                                coupon.discount_type == DiscountType.PERCENT
                            ) {
                                discount =
                                    p.booking_data.price * (discount / 100)
                            }

                            p.setBookingData({
                                ...p.booking_data,
                                coupon_code: coupon.code,
                                discount: coupon.discount_value,
                                discount_type: coupon.discount_type,
                                amount: p.booking_data.price
                                    ? p.booking_data.price - discount
                                    : 0,
                            })
                        }
                    } else {
                        delete p.booking_data.coupon_code
                        delete p.booking_data.discount
                        delete p.booking_data.discount_type
                        p.setBookingData({
                            ...p.booking_data,
                            amount: p.booking_data.price,
                        })
                    }
                }}
            />
        </form>
    ) : (
        <Translation
            render_as="div"
            content_key="no_payment_processor_integration"
            className="bg-red-100 px-3 py-2 rounded-lg mb-1 text-red-700"
        />
    )
}
